<template>
  <iframe src="https://calendar.google.com/calendar/embed?height=800&wkst=2&bgcolor=%23ffffff&ctz=Atlantic%2FCanary&showTitle=1&mode=WEEK&src=d2lraXRpLmRvZ2hvdW5kQGdtYWlsLmNvbQ&src=aXZjbjBqNmZ0Zzh0bDhkZzE5MnE1NDZiYXNAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&src=ZGFuaWVsLmhlcnpvZ0BjYXpvby5jb20&color=%234285F4&color=%230B8043&color=%23F4511E" style="border-width:0" width="1000" height="800" frameborder="0" scrolling="no"></iframe>
</template>

<script>
export default {
  name: 'calendar'
};
</script>
